/**
 * API Keys API
 */
import { apiClient } from './client'
import type { ApiKey, ApiKeyCreate, ApiKeyCreated, ApiKeyListResponse } from '../types'

const BASE_PATH = '/api/api-keys'

export const apiKeysApi = {
  list: async (): Promise<ApiKey[]> => {
    const response = await apiClient.get<ApiKeyListResponse>(BASE_PATH)
    return response.data.keys
  },

  create: async (data: ApiKeyCreate): Promise<ApiKeyCreated> => {
    const response = await apiClient.post<ApiKeyCreated>(BASE_PATH, data)
    return response.data
  },

  revoke: async (keyId: string): Promise<void> => {
    await apiClient.delete(`${BASE_PATH}/${keyId}`)
  },
}
